module.exports = __webpack_public_path__ + "fonts/dxicons.147eb6fe.ttf";